import FairePayPopoverVsDottedTooltipPage from "@faire/prototype-playground/workspace/ph/faire-pay-popover-vs-dotted-tooltip";
import { Route, Switch } from "react-router-dom";

export function PeiranHongRoutes() {
  return (
    <Switch>
      <Route
        path="/ph/faire-pay-popover-vs-dotted-tooltip"
        component={FairePayPopoverVsDottedTooltipPage}
      />
    </Switch>
  );
}

export const slug = "ph";
